module.exports = __webpack_public_path__ + "static/media/logo.11c32a76.png";